import { render, staticRenderFns } from "./DealerUsersEdit.vue?vue&type=template&id=0fedcb00&scoped=true"
import script from "./DealerUsersEdit.vue?vue&type=script&lang=js"
export * from "./DealerUsersEdit.vue?vue&type=script&lang=js"
import style0 from "./DealerUsersEdit.vue?vue&type=style&index=0&id=0fedcb00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fedcb00",
  null
  
)

export default component.exports